import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchBoxComponent {
  @Input() placeholder = 'Search by text or number...';
  @Output() search = new EventEmitter<string>();

  @ViewChild('searchInput', { static: true }) searchInput: ElementRef<HTMLInputElement>;

  submit(value: string): void {
    this.search.emit(value.trim());
  }

  clear(): void {
    this.searchInput.nativeElement.value = '';
    this.search.emit('');
  }
}
